import { stripIndent } from 'common-tags';
import { ClubMembershipDeactivatedEmail } from './components/ClubMembershipDeactivated';

export const clubMembershipDeactivatedEmailTemplate = {
  label: 'Club membership deactivated',
  description: 'When the subscription linked to the club membership is canceled',
  icon: 'ExchangeDollarLine',
  component: ClubMembershipDeactivatedEmail,
  defaultTemplate: {
    name: 'Club membership started',
    subject: {
      en: 'We are sad to see you leave',
      fr: 'Nous sommes tristes de vous voir partir',
      it: 'Siamo tristi di vederti partire',
      es: 'Nos entristece verte partir',
      de: 'Wir sind traurig, Sie gehen zu sehen',
    },
    templateVariables: {
      club_membership_started: {
        body: {
          en: stripIndent`
            <p>We are sad to see you leave</p>
          `,
          fr: stripIndent`
            <p>Nous sommes tristes de vous voir partir</p>
          `,
          it: stripIndent`
            <p>Siamo tristi di vederti partire</p>
          `,
          es: stripIndent`
            <p>Nos entristece verte partir</p>
          `,
          de: stripIndent`
            <p>Wir sind traurig, Sie gehen zu sehen</p>
          `,
        },
      },
    },
  },
  variables: [
    { key: 'customerFirstName', label: 'Customer First Name', example: 'John' },
    { key: 'customerLastName', label: 'Customer Last Name', example: 'Doe' },
    { key: 'customerEmail', label: 'Customer Email', example: 'john@example.com' },
    { key: 'storeName', label: 'Store Name', example: 'My Store' },
    { key: 'subscriptionName', label: 'Subscription Name', example: 'VIP Club' },
  ],
  utmParameters: {
    utmSource: 'club_membership_deactivated',
    utmMedium: 'email',
  },
  specificParams: undefined,
  mockData: (storeName = 'Demo Store') => ({
    store: {
      id: 'store_preview',
      name: storeName,
      baseCurrency: 'USD',
      presentmentCurrencies: ['USD'],
      chargeCurrencies: ['USD'],
    },
    customer: {
      firstName: 'John',
      lastName: 'Doe',
      email: 'john@example.com',
      locale: 'en-US',
      currency: 'USD',
    },
    subscription: {
      currency: 'USD',
      product: { name: 'VIP Club' },
    },
  }),
  defaultMessages: {
    promotion_title: 'Your Special Offer',
    promotion_subtitle: 'Use this code for your next purchase',
    cta_button: 'Shop Now',
    footer_text: '© 2024 All rights reserved',
  },
};
